<div class="container-fluid">
  <div class="row">
    <!-- Sidebar -->
    <div class="col-2 bg-light vh-100 p-3 d-flex flex-column">
      <h5 class="mb-3">Admin</h5>
      <ul class="nav flex-column flex-grow-1">
        <li class="nav-item">
          <a
            class="nav-link"
            href="#"
            [class.active]="isActive('/admin/user-management')"
            (click)="navigateTo('/admin/user-management', $event)"
            >Manage Users</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            href="#"
            [class.active]="isActive('/admin/project-management') || isActive('/admin/project-from-lesson')"
            (click)="navigateTo('/admin/project-management', $event)"
            >Manage Projects</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            href="#"
            [class.active]="isActive('/admin/customer-management')"
            (click)="navigateTo('/admin/customer-management', $event)"
            >Manage Customers</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            href="#"
            [class.active]="isActive('/admin/language-management')"
            (click)="navigateTo('/admin/language-management', $event)"
            >Manage Languages</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            href="#"
            [class.active]="isActive('/admin/service-credits')"
            (click)="navigateTo('/admin/service-credits', $event)"
            >Service credits</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            href="#"
            [class.active]="isActive('/admin/lesson-excel-import')"
            (click)="navigateTo('/admin/lesson-excel-import', $event)"
            >Excel lesson import</a
          >
        </li>
      </ul>
      <div class="border-top pt-3 mt-2 d-grid gap-2">
        <button type="button" class="btn btn-outline-secondary btn-sm text-start" (click)="goBack()">
          ← Back
        </button>
        <button type="button" class="btn btn-outline-danger btn-sm text-start" (click)="requestLogout()">
          Logout
        </button>
      </div>
    </div>

    <!-- Main content -->
    <div class="col-10 p-4">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
